<template>
    <div class="month" :class="{ 'is-actual' : actualMonth }">
        <h2 v-if="showYear" class="year">{{year}}</h2>
        <h3 class="month-name" :class="'week_start-' + startWeekDay">{{monthName}}</h3>

        <table>
            <tr class="week" v-for="(week,key) in weeks" v-bind:key="'month-' + key">
                <!--<td class="week-nr">{{ }}</td>-->
                <td class="day" :data-week="week.nr" v-for="(day,kd) in week.days" v-bind:key="kd" :class="day.type" @click="openDay(day)">
                    <span class="day-value">{{ day.val }}</span>
                    <kapp-kalender-event v-if="foundEvents(day.tstamp).length" :events="foundEvents(day.tstamp)" :tstamp="day.tstamp" />
                </td>
            </tr>
        </table>

    </div>
</template>

<script>

    import KappKalenderEvent from "../subparts/KappKalenderEvent";
    import ToggleBox from "../subparts/ToggleBox";
    // import KappEventsList from "./KappEventsList";

    export default {
        name: "KappKalenderMonth",
        props : ['month','events'],
        components : {
            'kapp-kalender-event' : KappKalenderEvent,

            'toggle-box' : ToggleBox
        },
        data () {
            return {
                today : new Date(),
                showDayData : false,
                selectedEvents : [],
                selectedDay : new Date(),
            }
        },
        computed : {
            showYear () {
                return ( this.$vnode.key === 0 || ( this.month % 12 )== 1);
            },
            year () {
                return this.monthDate.getFullYear();
            },
            actualMonth () {
                let today = new Date();
                if( this.monthDate.getMonth() === today.getMonth() )
                    return true;

                return false;
            },
            monthDate () {
                let date = new Date();
                date.setDate( 1 );
                date.setMonth( this.month - 1 );

                return date;
            },

            monthName : function () {
                return this.monthDate.toLocaleString('de-de', { month: 'long' } );
            },

            startWeekDay : function () {
                return parseInt( this.monthDate.getDay( ) ) - 1;
            },

            lastDay : function () {
                let date = new Date(this.today.getFullYear(), this.month, 0 );

                return date.getDate( );
            },

            weekCnt : function( ) {
                let dayCnt = this.lastDay + this.startWeekDay;

                return Math.ceil( dayCnt / 7 );
            },

            weeks : function() {

                let weeks = [],
                    monthDays = 0,
                    weekCnt = this.weekCnt;

                for( let w = 0; w < weekCnt; w++ ) {
                    let week = {
                        nr : ( new Date( this.today.getFullYear() , this.month-1, (monthDays+1) ).getWeek() ),
                        days : []
                    };

                    let x = (w == 0 ? this.startWeekDay : 0);

                    // erste Woche des Monats. Beinhaltet die fueller Tage des vorherigen Monats
                    if( w == 0 ) {

                        if( x < 0 ) {
                            x = x + 7;
                            weekCnt++;
                        }

                        for( let wd = 0; wd < x; wd++ ) {
                            let type = ['fueller'];

                            if( wd == 5 ) // Samstag ist noch vorheriger Monat
                                type.push( 'is-weekend' );

                            week.days.push( { type : type, val : ' ', tstamp : false });
                        }
                    }

                    // Regulaeren Monatstage
                    for( let d = x; d < 7; d++ ) {
                        if( monthDays < this.lastDay ) {
                            let date = new Date( this.today.getFullYear() , this.month-1, monthDays + 1, 12, 0 ),
                                type = ['regular'];

                            if( date.isSame( this.today, 'day' ) ) {
	                            type.push( 'is-today' );
                            }

                            if( date.getDay() == 0 || date.getDay() == 6 )
                                type.push( 'is-weekend' );
                            week.days.push( { type : type, val : monthDays + 1, tstamp : date.getTime()/1000 });
                        }
                        monthDays++;
                    }

                    weeks.push( week );
                }

                return weeks;
            },

        },
        methods : {
            foundEvents : function ( forDay ) {
                let eventList = [];

                if( forDay === false ) return eventList;

                eventList = this.events.filter( (evt, idx) => {
                    let start = new Date( evt.start * 1000 );
                    let end = new Date( evt.end * 1000 );
                    let day = new Date(forDay * 1000 );
	                if( day.isBetween( start, end, 'day' ) ) {
                        return true;
                    }

                }, forDay);

                eventList = eventList.sort( (a, b) => {
                    let aEnd = new Date( a.end * 1000 );
                    let bEnd = new Date( b.end * 1000 );

                    if( aEnd.getDay() === bEnd.getDay() ) {
                        if( aEnd.getHours() === bEnd.getHours()  ) return 0;
                        return ( aEnd.getHours() - bEnd.getHours()  );
                    }
                    return (bEnd.getDay() - aEnd.getDay());
                } );

                return eventList;

            },
            openDay : function( kd ) {
                let date = new Date(kd.tstamp * 1000);
                let eventsOfDay = this.events.filter(function (evt, idx) {
                	return this.date.isBetween(new Date(evt.start * 1000),
		                new Date(evt.end * 1000),
		                'day',)

                }, { date : date, app: this });
                Events.$emit( 'openSelectedList', eventsOfDay, date);
            },
            closeDay : function(){

            }
        },

        mounted () {
            if( this.actualMonth )
                this.$parent.$el.scrollTop = (this.$el.offsetTop - 137);
        }
    }
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/blocks/KappKalenderMonth.vue